import * as Icons from '@spotnana/pixel-react/dist/Icons';
import Tooltip from '@spotnana/pixel-react/dist/Tooltip';
import { TooltipIconContainer, TooltipText } from './styles';

interface IProps {
  toolTipText: string;
}

const TooltipInfo = ({ toolTipText }: IProps) => {
  return (
    <Tooltip
      variation="light"
      placement="bottom"
      interactive
      title={<TooltipText>{toolTipText}</TooltipText>}
      maxWidth="360px"
    >
      <TooltipIconContainer>
        <Icons.Info width={14} height={14} />
      </TooltipIconContainer>
    </Tooltip>
  );
};

export default TooltipInfo;
